import { useFlashMessageInvoiceReport } from '@/features/InvoiceReport/Edit/components/hooks/hooks';
import { WrapInlineNotification } from '@/features/InvoiceReport/Edit/components/WrapInlineNotification';
import classNames from 'classnames';
import { FC, memo, useEffect, useRef, useState } from 'react';
import styles from './FlashMessages.module.scss';

const cx = classNames.bind(styles);

type FlashMessage = {
  type?: 'warning' | 'error' | 'success' | 'info';
  message?: string;
};

export type Props = {
  flashMessages?: FlashMessage[];
};

export const FlashMessages: FC<Props> = memo(({ flashMessages }) => {
  const messages = useFlashMessageInvoiceReport(flashMessages);
  const [useRailsFlashMessage, setUseRailsFlashMessage] = useState(false);
  const ref = useRef<HTMLSlotElement | null>(null);
  useEffect(() => {
    if (!ref.current) return;
    const slotChange = () => {
      setUseRailsFlashMessage(true);
    };
    ref.current.addEventListener('slotchange', slotChange);
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ref.current?.removeEventListener('slotchange', slotChange);
    };
  }, []);

  return (
    <slot
      ref={ref}
      name='flash-messages'
      className={cx(styles['container'], {
        [styles['rails-flash-message']]: useRailsFlashMessage,
      })}
    >
      {messages?.map((item, key) => (
        <WrapInlineNotification
          key={key.toString()}
          type={item.type}
          isVisible={!!item.message}
          message={item.message ?? ''}
        />
      ))}
    </slot>
  );
});
FlashMessages.displayName = 'FlashMessages';
